export const API_VERSION = "v1";
export const IM_API_VERSION = "v1";
export const DATACENTER = "Datacenter";
export const MASTER = "Master";
export const DASHBOARD = "DashBoard";
export const HEALTHANDSAFETY = "HealthAndSafety";
export const STAFFING = "Staffing";
export const PERFORMANCE = "Performance";
export const USER = "USER";
export const Communication = "Communication";
export const Notification = "Notification";
export const SRPINTERNAL = "SRPInterApp";
export const WIDGET = "widget";
export const MAINTENANCE = "maintenance";
export const SECURITY = "security";
export const TENANT = "Tenant";
export const DocuSign = "DocuSign";
export const TENANTCONTACT = "TenantContact";
export const ULTIPRO = "UltiProService";
export const REQUEST = "Request";
export const REPORT = "Report";
export const SecurityIncident = "SecurityIncident";
export const FacilityPerformance = "FacilityPerformance";

export const API_HEADERS = {
	authName: "Bearer",
	authToken: "adal.idtoken",
	CID: "CID",
	AGI: "AGI" //AccessGroupId
};

/**
 * get / Return current environment
 * @returns
 */
export function getCurrentEnvironment() {
	let environment = "dev";
	let clientId = "2b1e537e-9f0d-46ba-b4de-291a3948181a";
	let isLocal = false;
	if (
		window.location.href.indexOf("ui-dcopl-prd-eus") >= 0 ||
		window.location.href.indexOf("https://dcop.stream-dc.com") >= 0
	) {
		clientId = "b3ea8035-a4ed-49ac-a3c8-83117805df09";
		environment = "prod";
	} else if (window.location.href.indexOf("ui-dcopl-stg-eus") > 0 || window.location.href.indexOf("stage-dcop.stream-dc") >= 0) {
		environment = "stage";
		clientId = "e3cb6b2f-6cea-4f43-a7c3-fe8cf9df3da7";
	} else if (window.location.href.indexOf("ui-dcopl-tst-eus") > 0 || window.location.href.indexOf("test-dcop.stream-dc") >= 0) {
		environment = "test";
		clientId = "b6c21d77-c4bd-4090-ac83-a8aad368ebc5";
	} else if (window.location.href.indexOf("localhost") > 0) {
		environment = "dev";
		isLocal = false;
	} else if (window.location.href.indexOf("ui-dcopl-dev-eus") > 0 || window.location.href.indexOf("dev-dcop.stream-dc") >= 0) {
		environment = "dev";
	}

	return { environment: environment, isLocal: isLocal, clientId: clientId };
}

/**
 * get environment wise testing
 * @returns
 */
export function getEnvironmentWiseTesting() {
	const env = getCurrentEnvironment();

	if (env.environment === "prod") {
		return "Production Testing";
	} else if (env.environment === "stage") {
		return "Stage Testing";
	} else if (env.environment === "test") {
		return "Test Testing";
	} else {
		return "Dev Testing"
	}
}

/**
 * Application Swagger URL
 * @returns
 */
export function getSwaggerUrl() {
	const env = getCurrentEnvironment();

	if (!env.isLocal) {
		if (
			window.location.href.indexOf("ui-dcopl-prd-eus") >= 0 ||
			window.location.href.indexOf("https://dcop.stream-dc.com") >= 0 
		) {
			return `https://dcop.stream-dc.com/api-v1/swagger/index.html?urls.primaryName=ApiVersion%20-%20V2`;
		} else {
			if (env.environment === "prod") {
				return `https://dcop.stream-dc.com/api-v1/swagger/index.html?urls.primaryName=ApiVersion%20-%20V2`;
				// return `https://${env.environment}-dcop-api.stream-dc.com/swagger/index.html?urls.primaryName=ApiVersion%20-%20V2`;
			} else if (env.environment === "stage"){
				// return `https://app-api-dcopl-stg-eus.azurewebsites.net/swagger/index.html?urls.primaryName=ApiVersion%20-%20V2`;
				return `https://${env.environment}-dcop.stream-dc.com/api-v1/swagger/index.html?urls.primaryName=ApiVersion%20-%20V2`;
			} else if (env.environment === "test"){
				// return `https://app-api-dcopl-tst-eus.azurewebsites.net/swagger/index.html?urls.primaryName=ApiVersion%20-%20V2`;
				return `https://${env.environment}-dcop.stream-dc.com/api-v1/swagger/index.html?urls.primaryName=ApiVersion%20-%20V2`;
			}
			else {
				// return `https://app-api-dcopl-${env.environment}-eus.azurewebsites.net/swagger/index.html?urls.primaryName=ApiVersion%20-%20V2`;
				return `https://${env.environment}-dcop-api.stream-dc.com/swagger/index.html?urls.primaryName=ApiVersion%20-%20V2`;
			}
		}
	} else {
		return "http://localhost:61727/swagger/index.html?urls.primaryName=ApiVersion%20-%20V2";
	}
}

/**
 * Application base URL
 * @returns
 */
export function getBaseUrl() {
	const env = getCurrentEnvironment();

	if (!env.isLocal) {
		if (window.location.href.indexOf("ui-dcopl-prd-eus") >= 0 ||
			window.location.href.indexOf("https://dcop.stream-dc.com") >= 0 ) {
			return `https://dcop.stream-dc.com/api-v1/api`;
		} else {
			if (env.environment === "prod") {
				// return `https://app-api-dcopl-prd-eus.azurewebsites.net/api`;
			    return `https://dcop-api.stream-dc.com/api`;
			} else if (env.environment === "stage") {
				// return `https://app-api-dcopl-stg-eus.azurewebsites.net/api`;
				return `https://${env.environment}-dcop.stream-dc.com/api-v1/api`;
			} else if (env.environment === "test") {
				// return `https://app-api-dcopl-tst-eus.azurewebsites.net/api`;
				return `https://${env.environment}-dcop.stream-dc.com/api-v1/api`;
			} else {
				// return `https://app-api-dcopl-${env.environment}-eus.azurewebsites.net/api`;
				return `https://${env.environment}-dcop-api.stream-dc.com/api`;
			}
		}
	} else {
		return "http://localhost:61727/api";
	}
}

/**
	 * create API URL
 * @param {*} apiName - api name
 * @returns
 */
function createApiUrl(apiName) {
	return `${getBaseUrl()}/${API_VERSION}/${apiName}`;
}

/**
 * Create IMApi URL
 * @param {*} apiName - api name
 * @returns
 */
function createIMApiUrl(apiName) {
	return `${getBaseUrl()}/${API_VERSION}/${apiName}`;
}

export const API_URL = {
	getReportDownload: createApiUrl("SSRSReport/GetReport"),
	tenant: {
		Authenticate: createApiUrl(`${TENANT}/Authenticate`),

		RefreshToken: createApiUrl(`${TENANT}/RefreshToken`),

		Register: createApiUrl(`${TENANT}/Register`),

		VerifyOTP: createApiUrl(`${TENANT}/VerifyOTP`),

		ResendOTP: createApiUrl(`${TENANT}/ResendOTP`),

		ContactUs: createApiUrl(`${TENANT}/ContactUs`),

		ForgotPassword: createApiUrl(`${TENANT}/ForgotPassword`),

		GetTenants: createApiUrl(`${TENANT}/GetTenants`),

		GetTenantById: createApiUrl(`${TENANT}/GetTenantById`),

		DeleteTenant: createApiUrl(`${TENANT}/DeleteTenant`),

		AddTenant: createApiUrl(`${TENANT}/AddTenant`),

		UpdateTenant: createApiUrl(`${TENANT}/UpdateTenant`),

		GenerateApiToken: createApiUrl(`${TENANT}/GenerateApiToken`),
		
		deleteApiToken: createApiUrl(`${TENANT}/DeleteApiToken`)
	},

	tenantContact: {
		GetTenantContacts: createApiUrl(`${TENANTCONTACT}/GetTenantContacts`),

		GetTenantContactById: createApiUrl(`${TENANTCONTACT}/GetTenantContactById`),

		SendEmailNotification: createApiUrl(
			`${TENANTCONTACT}/SendEmailNotification`
		),

		AddTenantContact: createApiUrl(`${TENANTCONTACT}/AddTenantContact`),

		UpdateTenantContact: createApiUrl(`${TENANTCONTACT}/UpdateTenantContact`)
	},

	request: {
		GetRequestsList: createApiUrl(`${REQUEST}/GetRequestsList`),
		GetUserSiteInfo: createApiUrl(`${REQUEST}/GetUserSiteInfo`),
		GetRequestTypesForUser: createApiUrl(`${REQUEST}/GetRequestTypesForUser`),
		GetRequestDetailsById: createApiUrl(`${REQUEST}/GetRequestDetailsById`),
		GetRequestDetailsByRequestType: createApiUrl(
			`${REQUEST}/GetRequestDetailsByRequestType`
		),
		CreateRequest: createApiUrl(`${REQUEST}/CreateRequest`),
		UpdateRequest: createApiUrl(`${REQUEST}/UpdateRequest`),
		DeleteRequest: createApiUrl(`${REQUEST}/DeleteRequest`),
		ResponseToRequest: createApiUrl(`${REQUEST}/ResponseToRequest`),
		GetRequestTypeDepartmentMapping: createApiUrl(
			`${REQUEST}/GetRequestTypeDepartmentMapping`
		),
		GetRequestMasterData: createApiUrl(`${REQUEST}/GetRequestMasterData`),
		AddRequestTypeDepartmentMapping: createApiUrl(
			`${REQUEST}/AddRequestTypeDepartmentMapping`
		),
		UpdateRequestTypeDepartmentMapping: createApiUrl(
			`${REQUEST}/UpdateRequestTypeDepartmentMapping`
		),
		DeleteRequestTypeDepartmentMapping: createApiUrl(
			`${REQUEST}/DeleteRequestTypeDepartmentMapping`
		),
		GetTenantServiceLocations: createApiUrl(
			`${REQUEST}/GetTenantServiceLocations`
		),
		updateReqAccessInOutTime: createApiUrl(`${REQUEST}/UpdateVisitorDetails`),
		UpdateRequestAttachment: createApiUrl(`${REQUEST}/UpdateRequestAttachment`),
		GetRequestSearchDetails: createApiUrl(`${REQUEST}/GetRequestSearchDetails`),
		UpdateABRFSigningDetails: createApiUrl(
			`${REQUEST}/UpdateABRFSigningDetails`
		),
		GetPhysicalKeyGrantRequest: createApiUrl(
			`${REQUEST}/GetPhysicalKeyGrantRequest`
		),
		SaveRequestBiometricsForm: createApiUrl(
			`${REQUEST}/SaveRequestBiometricsForm`
		)
	},

	datacenter: {
		GetTenantDetailsByProperty: createApiUrl(
			`${DATACENTER}/GetTenantDetailsByProperty`
		),
		GetDataSyncStatus: createApiUrl(`${DATACENTER}/GetDataSyncStatus`),
		GetMissingDataSyncStatus: createApiUrl(
			`${DATACENTER}/GetMissingSourceData`
		),
		GetDataSource: createApiUrl(`${DATACENTER}/GetDataSource`),
		GetSyncStatus: createApiUrl(`${DATACENTER}/GetSyncStatus`),

		UpdateDataCenterTenant: createApiUrl(
			`${DATACENTER}/UpdateDataCenterTenant`
		),
		GetDataHallCapacityByProperty: createApiUrl(
			`${DATACENTER}/GetDataHallCapacityByProperty`
		),
		UpdateDataCenterAttribute: createApiUrl(
			`${DATACENTER}/UpdateDataCenterAttribute`
		),
		getDatacenterList: createApiUrl(`${DATACENTER}/GetDatacenterList`),

		GetOperators: createApiUrl(`${DATACENTER}/GetOperators`),
		GetServiceLocations: createApiUrl(`${DATACENTER}/GetServiceLocations`),
		GetServiceLocationSides: createApiUrl(
			`${DATACENTER}/GetServiceLocationSides`
		),
		GetBmsSource: createApiUrl(`${DATACENTER}/GetBmsSource`),
		GetSectionMappingByGroup: createApiUrl(
			`${DATACENTER}/GetSectionMappingByGroup`
		),
		UpdateSectionMapping: createApiUrl(`${DATACENTER}/UpdateSectionMapping`),
		GetAllUltiProLocation: createApiUrl(`${DATACENTER}/GetAllUltiProLocation`),
		GetAllUltiProProperty: createApiUrl(`${DATACENTER}/GetAllUltiProProperty`),
		GetEmpPropertyMaster: createApiUrl(
			`${DATACENTER}/GetEmployeeDatacenterMasterData`
		),
		GetEmpPropertyList: createApiUrl(
			`${DATACENTER}/GetEmployeeAndPropertyList`
		),
		updateEmpPropertyList: createApiUrl(
			`${DATACENTER}/UpdateEmployeeDatacenterMapping`
		),
		addEmpPropertyList: createApiUrl(
			`${DATACENTER}/AddEmployeeDatacenterMapping`
		),
		deleteEmpPropertyList: createApiUrl(
			`${DATACENTER}/DeleteEmployeeDatacenterMapping`
		),
		addUpdateEmployee: createApiUrl(`${DATACENTER}/AddUpdateEmployee`)
	},
	masterData: {
		GetOperators: createApiUrl(`${MASTER}/GetOperators`),
		GetServiceLocations: createApiUrl(`${MASTER}/GetServiceLocations`),
		GetServiceLocationSides: createApiUrl(`${MASTER}/GetServiceLocationSides`),
		GetBmsSource: createApiUrl(`${MASTER}/GetBmsSource`),
		GetPointList: createApiUrl(`${MASTER}/GetPointList`),
		GetRequestMasterData: createApiUrl(`${REQUEST}/GetRequestMasterData`),
		GetLabels: createApiUrl(`${MASTER}/GetLabels`),
		GetCountryStateMasterData: createApiUrl(
			`${MASTER}/GetCountryStateMasterData`
		)
	},
	widget: {
		GetWidgetMasterList: createApiUrl(`${WIDGET}/GetWidgetMasterList`),
		UpdateUserWidgetMapping: createApiUrl(`${WIDGET}/UpdateUserWidgetMapping`),
		RemoveUserWidgetMapping: createApiUrl(`${WIDGET}/RemoveUserWidgetMapping`),
		AddWidgetMapping: createApiUrl(`${WIDGET}/AddUserWidgetMapping`),
		GetWidgetMasterDataList: createApiUrl(`${WIDGET}/GetWidgetMasterDataList`),
		GetWidgetSourceData: createApiUrl(`${WIDGET}/GetWidgetDataByDataSource`),
		GetWidgetSourceList: createApiUrl(`${WIDGET}/GetWidgetSourceList`),
		UpdateWidgetMaster: createApiUrl(`${WIDGET}/UpdateWidgetMaster`),

		GetWidgetDataByDataSource: createApiUrl(
			`${WIDGET}/GetWidgetDataByDataSource`
		),

		ResetUserWidgetsToDefault: createApiUrl(
			`${WIDGET}/ResetUserWidgetsToDefault`
		),
		GetWidgetMasterListByGroup: createApiUrl(
			`${WIDGET}/GetWidgetMasterListByGroup`
		),
		UpdateGroupWidgetMapping: createApiUrl(`${WIDGET}/UpdateGroupWidgetMapping`)
	},
	Communication: {
		GetCommunicationLogMasterRecipient: createApiUrl(
			`${Communication}/GetCommunicationLogMasterRecipient`
		),
		GetCommunicationLogRecipient: createApiUrl(
			`${Communication}/GetCommunicationLogRecipient`
		),
		CreateCommunicationLog: createApiUrl(
			`${Communication}/CreateCommunicationLog`
		),
		GetCommunicationLogByGroup: createApiUrl(
			`${Communication}/GetCommunicationLogByGroup`
		),
		GetCommunicationMaster: createApiUrl(
			`${Communication}/GetCommunicationMaster`
		)
	},
	Notification: {
		List: createApiUrl(`${Notification}/List`),
		Get: createApiUrl(`${Notification}/Get`),
		Delete: createApiUrl(`${Notification}/Delete`),
		Put: createApiUrl(`${Notification}/Put`)
	},
	// Profile/User related API
	user: {
		GetUserConfigurationDetails: createApiUrl(
			`${USER}/GetUserConfigurationDetails`
		),
		GetUserOrganizationDetails: createApiUrl(
			`${USER}/GetUserOrganizationDetails`
		),

		GetAccessGroups: createApiUrl(`${USER}/GetAccessGroups`),
		SendEmailNotification: createApiUrl(`${USER}/SendEmailNotification`),
		GetRoutingMaster: createApiUrl(`${USER}/GetRoutingMaster`),
		GetRoutingConfigurations: createApiUrl(`${USER}/GetRoutingConfigurations`),
		SaveRoutingConfiguration: createApiUrl(`${USER}/SaveRoutingConfiguration`),
		UpdateDistributionGroupRecipient: createApiUrl(
			`${USER}/UpdateDistributionGroupRecipient`
		),
		UpdateUserLoginLog: createApiUrl(`${USER}/UpdateUserLoginLog`),
		GetHistoryOfAPIKey: createApiUrl(`${USER}/GetHistoryOfAPIKey`),
	},

	security: {
		GetAccessDenialsSummaryByDate: createApiUrl(
			`${SECURITY}/GetAccessDenialsSummaryByDate`
		),

		GetGuardForcePatrolsByProperty: createApiUrl(
			`${SECURITY}/GetGuardForcePatrolsByProperty`
		)
	},

	criticalEngSummary: {
		getCriticalEngSummary: createApiUrl(
			`${DASHBOARD}/GetCriticalEngineeringSummaryByDate`
		)
	},

	guardForceStaffingSummary: {
		getGuardForceStaffingSummary: createApiUrl(
			`${DASHBOARD}/GetGuardForceStaffingSummaryByDate`
		)
	},

	StaffingSummary: {
		GetStaffingSummaryByDate: createApiUrl(
			`${DASHBOARD}/GetStaffingSummaryByDate`
		)
	},

	MaintenanceSummary: {
		GetMaintenanceSummaryByDate: createApiUrl(
			`${DASHBOARD}/GetMaintenanceSummaryByDate`
		)
	},

	GuardForcePatrolSummary: {
		GetGuardForcePatrolSummaryByDate: createApiUrl(
			`${DASHBOARD}/GetGuardForcePatrolSummaryByDate`
		)
	},

	GuardForceStaffingSummary: {
		GetGuardForceStaffingSummaryByDate: createApiUrl(
			`${DASHBOARD}/GetGuardForceStaffingSummaryByDate`
		)
	},

	SiteVisitorSummary: {
		GetSiteVisitorSummaryByDate: createApiUrl(
			`${DASHBOARD}/GetSiteVisitorSummaryByDate`
		)
	},

	IncidentReportingSummary: {
		GetIncidentReportingSummaryByDate: createApiUrl(
			`${DASHBOARD}/GetIncidentReportingSummaryByDate`
		)
	},
	dashBoard: {
		GetIncidentReportingSummaryByMonth: createApiUrl(
			`${DASHBOARD}/GetIncidentReportingSummaryByMonth`
		),

		IncidentReportingDetailsByDate: createApiUrl(
			`${DASHBOARD}/GetIncidentReportingDetailsByDate`
		),

		MaintenanceDetailsByDate: createApiUrl(
			`${DASHBOARD}/GetMaintenanceDetailsByDate`
		),

		getDatacenterListWithLocation: createApiUrl(
			`${DATACENTER}/GetDatacenterWithLocation`
		)
	},
	reports: {
		HealthAndSafetyIncidentSummary: createApiUrl(
			`${HEALTHANDSAFETY}/GetHealthAndSafetyIncidentSummaryByCategory`
		),

		RecordableIncidentByMonth: createApiUrl(
			`${HEALTHANDSAFETY}/GetTotalRecordableIncidentByMonth`
		),

		TotalRecordableIncidentSummary: createApiUrl(
			`${HEALTHANDSAFETY}/GetTotalRecordableIncidentSummaryByYTD`
		),

		GetHSEIncidentKPISummary: createApiUrl(
			`${HEALTHANDSAFETY}/GetHSEIncidentKPISummary`
		),

		StaffingDetailsByMonth: createApiUrl(
			`${STAFFING}/GetStaffingDetailsByMonth`
		),

		DeleteStaffingDetails: createApiUrl(
			`${STAFFING}/DeleteStaffingDetailsByMonth`
		),

		UpdateStaffingHoursByMonth: createApiUrl(
			`${STAFFING}/UpdateStaffingHoursByMonth`
		),

		StaffMasterList: createApiUrl(`${STAFFING}/GetStaffMasterList`),

		RoleMasterList: createApiUrl(`${STAFFING}/GetGetOrgRoleMasterList`),

		UpdateStaffingDetails: createApiUrl(
			`${STAFFING}/UpdateStaffingDetailsByMonth`
		),

		PerformanceSummary: createApiUrl(
			`${PERFORMANCE}/GetPerformanceSummaryReportByMonth`
		),

		PerformanceDetailByDate: createApiUrl(
			`${PERFORMANCE}/GetPerformanceDetailReportByDate`
		),
		PerformanceTrendByDate: createApiUrl(
			`${PERFORMANCE}/GetPerformanceTrendByMonth`
		)
	},

	performance: {
		GetPerformanceReportListByProperty: createApiUrl(
			`${PERFORMANCE}/GetPerformanceReportListByProperty`
		),
		GetPerformanceLookUpMasterTables: createApiUrl(
			`${PERFORMANCE}/GetPerformanceLookUpMasterTables`
		),
		GetPerformanceLookUpAttributes: createApiUrl(
			`${PERFORMANCE}/GetPerformanceLookUpAttributes`
		),
		GetPerformanceReportAttribute: createApiUrl(
			`${PERFORMANCE}/GetPerformanceReportAttribute`
		),

		UpdatePerformanceReports: createApiUrl(
			`${PERFORMANCE}/UpdatePerformanceReports`
		),

		UpdateAttribute: createApiUrl(
			`${PERFORMANCE}/UpdatePerformanceReportAttribute`
		),
		LoadPerformanceAttributeHistoricalData: createApiUrl(
			`${PERFORMANCE}/LoadPerformanceAttributeHistoricalData`
		)
	},
	maintenance: {
		// HighSeverityIssueDetails: createApiUrl(
		//   `${MAINTENANCE}/GetHighSeverityIssueDetailsByMonth`
		// ),

		HighSeverityIssueDetails: createApiUrl(
			`${MAINTENANCE}/GetHighSeverityIssueDetailsByMonth`
		),

		MaintenanceNotCompletedSummary: createApiUrl(
			`${MAINTENANCE}/GetMaintenanceNotCompletedSummaryByMonth`
		),

		MaintenanceCompletedSummary: createApiUrl(
			`${MAINTENANCE}/GetMaintenanceCompletedSummaryByMonth`
		),

		MaintenanceInProgressSummary: createApiUrl(
			`${MAINTENANCE}/GetMaintenanceInProgressSummary`
		),
		CustomerNotificationSent: createApiUrl(
			`${MAINTENANCE}/GetCustomerNotificationSummaryByMonth`
		)
	},

	config: {
		GetPropertyIdByPropertyCode: createIMApiUrl(
			`${SRPINTERNAL}/GetPropertyIdByPropertyCode`
		),

		UpdateDataCenterConfiguration: createApiUrl(
			`${DATACENTER}/UpdateDataCenterConfiguration`
		)
	},

	finance: {
		GetPropertyFinanceSummaryByPropertyKey: createIMApiUrl(
			`${SRPINTERNAL}/GetPropertyFinanceSummaryByPropertyKey`
		),

		GetPropertyFinanceDetails: createIMApiUrl(
			`${SRPINTERNAL}/GetPropertyFinanceDetailsByPropertyKey`
		),

		GetOperatingSummary: createIMApiUrl(`${SRPINTERNAL}/GetOperatingSummary`),

		UpdateKwForProperty: createIMApiUrl(`${SRPINTERNAL}/UpdateKwForProperty`)
	},

	UltiProService: {
		GetAllLocations: createIMApiUrl(`${ULTIPRO}/GetAllLocations`),
		GetOrganizationLevel1Details: createIMApiUrl(
			`${ULTIPRO}/GetOrganizationLevel1Details`
		),
		GetOrganizationLevel4Details: createIMApiUrl(
			`${ULTIPRO}/GetOrganizationLevel4Details`
		)
	},
	brr: {
		authenticateUrl: createApiUrl(`${TENANT}/AuthenticateForBRR`),
		verifyBRROtp: createApiUrl(`${TENANT}/VerifyBRROTP`),
		getEnvelopDetail: createApiUrl(`${TENANT}/GetEnvelopDetailsByRequestId`),
		generateBRRLink: createApiUrl(`${DocuSign}/GenerateESigningUrl`),
		getEnvelopStatus: createApiUrl(`${DocuSign}/GetEnvelopStatus`),
		signedEnvelop: createApiUrl(`${TENANT}/SignedEnvelop`),
		resentBrrOtp: createApiUrl(`${TENANT}/ResendOtpForBRR`)
		// postEnvelopData : createIMApiUrl(`${DocuSign}/PostEnvelopData`)
	},

	reporting: {
		getAllReports: createApiUrl(`${REPORT}/GetAllReports`),
		getFilters: createApiUrl(`${REPORT}/GetFilters`),
		generateReport: createApiUrl(`${REPORT}/GenerateReport`),
		getReportData: createApiUrl(`${REPORT}/GetReportData`)
	},
	getSPSToken: createApiUrl(`${USER}/AcquireSPToken`),
	getNotes: createApiUrl(`${MAINTENANCE}/GetWorkOrderNoteByWorkOrderNumber`),
	baseUrl: createApiUrl(`${DASHBOARD}/`),
	healthSafety: {
		getIncidentList: createApiUrl(`${HEALTHANDSAFETY}/GetAllHSEIncident`),
		getIncidentById: createApiUrl(`${HEALTHANDSAFETY}/GetHSEIncidentById`),
		getIncidentMasterData: createApiUrl(`${HEALTHANDSAFETY}/GetHSEMasterData`),
		CreateIncident: createApiUrl(`${HEALTHANDSAFETY}/CreateIncident`),
		UpdateIncident: createApiUrl(`${HEALTHANDSAFETY}/UpdateIncident`),
		DeleteHSEObservation: createApiUrl(
			`${HEALTHANDSAFETY}/DeleteHSEObservation`
		)
	},
	securityIncident: {
		getSecurityIncidentList: createApiUrl(
			`${SecurityIncident}/GetAllSecurityIncident`
		),
		getSecurityIncidentById: createApiUrl(
			`${SecurityIncident}/GetSecurityIncidentById`
		),
		getSecurityIncidentMasterData: createApiUrl(
			`${SecurityIncident}/GetSecurityMasterData`
		),
		CreateSecurityIncident: createApiUrl(
			`${SecurityIncident}/CreateSecurityIncident`
		),
		UpdateSecurityIncident: createApiUrl(
			`${SecurityIncident}/UpdateSecurityIncident`
		),
		DeleteSecurityIncident: createApiUrl(
			`${SecurityIncident}/DeleteSecurityIncident`
		),
		GetEmailLog: createApiUrl(
			`${SecurityIncident}/GetEmailLog`
		),		
		GetSecurityIncidentMasterDataConfiguration: createApiUrl(
			`${SecurityIncident}/GetSecurityIncidentMasterDataConfiguration`
		),
		ModifySecurityCategory: createApiUrl(
			`${SecurityIncident}/ModifySecurityCategory`
		),
		ModifySecurityIncidentStatus: createApiUrl(
			`${SecurityIncident}/ModifySecurityIncidentStatus`
		),
		ModifySecuritySubCategory: createApiUrl(
			`${SecurityIncident}/ModifySecuritySubCategory`
		),
		SaveSecurityIncidentCategory: createApiUrl(
			`${SecurityIncident}/SaveSecurityIncidentCategory`
		),
		SaveSecurityIncidentStatus: createApiUrl(
			`${SecurityIncident}/SaveSecurityIncidentStatus`
		),
		SaveSecurityIncidentSubCategory: createApiUrl(
			`${SecurityIncident}/SaveSecurityIncidentSubCategory`
		),
		
	},
	facilityPerformance: {
		getFacilityPerformanceSection: createApiUrl(
			`${FacilityPerformance}/GetFacilityPerformanceSection`
		)
	}
};
